import { render } from "./NoteItem.vue?vue&type=template&id=f77b6354&scoped=true&ts=true"
import script from "./NoteItem.vue?vue&type=script&lang=ts"
export * from "./NoteItem.vue?vue&type=script&lang=ts"

import "./NoteItem.vue?vue&type=style&index=0&id=f77b6354&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77b6354"]])

export default __exports__